import { Link } from 'react-router';
import Notice from '@/shared/ui/Notice';

/** Al posto del modulo quando il link dell'email non porta il token. */
export default function ResetLinkMissing() {
  return (
    <Notice tone="warning" className="mt-6">
      Il link non è valido o è incompleto.{' '}
      <Link
        to="/forgot-password"
        className="rounded-xs font-medium text-link underline focus-visible:focus-ring"
      >
        Richiedi un nuovo link
      </Link>{' '}
      per reimpostare la password.
    </Notice>
  );
}
